exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-container .el-form[data-v-5083cbe0]{display:flex;flex-wrap:wrap;gap:5%}.action-container .el-form>.el-form-item[data-v-5083cbe0]{margin-right:inherit;flex-basis:30%;flex-shrink:0}.tips[data-v-5083cbe0]{color:red}\n", ""]);

// exports
